<div class="page">
  <kgrid
    [apiName]="apiName"
    [noAutoFitColumns]="true"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    reportName=""
    pathPreFix="SALE"
    [isMulti]="true"
    [unSortableFilterable]=""
    [isEdit]="true"
    [isDelete]="false"
    [filters]=""
    [hideToolber]="true"
    (onRowSelected)="onRowSelected($event)"
    (onDoubleClick)="showInfo($event)">
  </kgrid>
  <div class="footer">
    <ssg-button class="btn-close" [label]="'ClientApp.FrontOffice.Inv.DailyHeader.Close' | translate" (click)="close()"></ssg-button>
    <ssg-button class="btn-ok" [label]="'ClientApp.FrontOffice.Inv.DailyHeader.Confirm' | translate" (click)="confirm()"></ssg-button>
  </div>
</div>
